<script>
export default {
    props: {
        land_lease: { type: Object, required: true }
    }
};
</script>

<template>
    <div>
        <h4>{{ $t("land_leases.notes") }}</h4>
        <div
            v-if="land_lease.notes"
            v-html="$options.filters.nl2br(land_lease.notes)"
        ></div>
        <div v-else class="text-muted">
            {{ $t("land_leases.no_notes") }}
        </div>
    </div>
</template>
